import { useSplide } from '~/lib/splide'


document.addEventListener('DOMContentLoaded', () => {

  const tabs = document.querySelectorAll('.cotizador-tab');
  const sliders = document.querySelectorAll('.cotizador-slider');
  const selectTipologias = document.querySelector('span.select-tipologias select') as HTMLSelectElement | null;
  // Guardar el índice activo del slider por piso
  const activeSlideByPiso: Record<string, number> = {};

  function getSlidesByPiso(piso: string): NodeListOf<HTMLElement> | null {
    const slider = document.getElementById('cotizador-piso-' + piso);
    return slider ? slider.querySelectorAll('.splide__slide') as NodeListOf<HTMLElement> : null;
  }

  function updateSelectTipologias(piso: string, selectedKey?: string) {
    if (!selectTipologias) return;
    const slides = getSlidesByPiso(piso);
    if (!slides) return;
    selectTipologias.innerHTML = '';
    const seen = new Set<string>();
    let selectedIndex = 0;
    let idx = 0;
    slides.forEach(slide => {
      const tipologia = slide.getAttribute('data-tipologia') || '';
      const dormitorios = slide.getAttribute('data-dormitorios') || '';
      if (tipologia && dormitorios) {
        const key = `${dormitorios}|${tipologia}`;
        if (!seen.has(key)) {
          seen.add(key);
          const option = document.createElement('option');
          option.value = key;
          option.textContent = `${dormitorios} dormitorios / ${tipologia}`;
          if (selectedKey && key === selectedKey) {
            selectedIndex = idx;
          }
          selectTipologias.appendChild(option);
          idx++;
        }
      }
    });
    selectTipologias.selectedIndex = selectedIndex;
  }

  function setTabActive(tab: HTMLElement) {
    tabs.forEach(t => t.classList.remove('active', 'bg-anden-primary', 'text-white', 'z-2'));
    sliders.forEach(s => (s instanceof HTMLElement ? s.classList.add('hidden') : null));
    tab.classList.add('active', 'bg-anden-primary', 'text-white', 'z-2');
    const piso = tab.getAttribute('data-piso');
    const slider = document.getElementById('cotizador-piso-' + piso);
    if (slider) slider.classList.remove('hidden');
    if (piso) {
      // Siempre seleccionar el primer slide y la primera opción del select
      updateSelectTipologias(piso);
      const splideInstance = splideByPiso[piso];
      if (splideInstance) {
        splideInstance.go(0);
      }
      if (selectTipologias) {
        selectTipologias.selectedIndex = 0;
      }
    }
  }

  // Helper para obtener el key del slide por índice
  function getKeyBySlideIdx(piso: string, idx: number): string | undefined {
    const slides = getSlidesByPiso(piso);
    if (!slides || !slides[idx]) return undefined;
    const slide = slides[idx];
    const tipologia = slide.getAttribute('data-tipologia') || '';
    const dormitorios = slide.getAttribute('data-dormitorios') || '';
    return `${dormitorios}|${tipologia}`;
  }

  // Guardar instancia de splide por piso
  const splideByPiso: Record<string, any> = {};

  // Inicializar el select con el primer tab activo
  const firstTab = document.querySelector('.cotizador-tab.active') as HTMLElement | null;
  if (firstTab) setTabActive(firstTab);

  tabs.forEach(tab => {
    tab.addEventListener('click', function (this: HTMLElement) {
      setTabActive(this);
    });
  });

  document.querySelectorAll('.cotizador__home').forEach((el) => {
    const piso = (el as HTMLElement).getAttribute('data-piso') || '';
    useSplide(el as HTMLElement, {
      arrows: true,
      pagination: false,
    })?.then((splide) => {
      splideByPiso[piso] = splide;
      // Slider -> Select
      splide?.on('mounted move', () => {
        const slides = (el as HTMLElement).querySelectorAll('.splide__slide');
        const activeIdx = splide?.index ?? 0;
        activeSlideByPiso[piso] = activeIdx;
        const activeSlide = slides[activeIdx] as HTMLElement;
        if (activeSlide && piso) {
          const { titulo = '', terreno = '', area = '', dormitorios = '', tipologia = '' } = activeSlide.dataset;
          const key = `${dormitorios}|${tipologia}`;
          const titleEl = document.getElementById('cotizador-title-' + piso);
          const dormsEl = document.getElementById('cotizador-dorms-' + piso);
          const infoEl = document.getElementById('cotizador-info-' + piso);
          if (titleEl) titleEl.textContent = titulo;
          if (dormsEl) dormsEl.textContent = `${dormitorios} Dormitorios`;
          if (infoEl) infoEl.textContent = `Terreno ${terreno} / Área construida: ${area}`;
          if (selectTipologias && key) {
            for (let i = 0; i < selectTipologias.options.length; i++) {
              if (selectTipologias.options[i].value === key) {
                selectTipologias.selectedIndex = i;
                break;
              }
            }
          }
        }
      });
      // Select -> Slider
      if (selectTipologias) {
        selectTipologias.addEventListener('change', function () {
          const value = selectTipologias.value;
          const slides = (el as HTMLElement).querySelectorAll('.splide__slide');
          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i] as HTMLElement;
            const tipologia = slide.getAttribute('data-tipologia') || '';
            const dormitorios = slide.getAttribute('data-dormitorios') || '';
            const key = `${dormitorios}|${tipologia}`;
            if (key === value && splide) {
              splide.go(i);
              activeSlideByPiso[piso] = i;
              break;
            }
          }
        });
      }
      splide?.mount();
    });
  });


});